/* eslint-disable max-len */

// TODO: migrate this file to be a blueprint itself similarly done with OrderCart/V1

import { rebillyProcessOrder } from './rebilly_element'
import { defaultDomains, defaultSecondLevelDomains, defaultTopLevelDomains } from './vendor/mailCheck/domains'
import { Mailcheck } from './vendor/mailCheck/main'
// import $ from 'jquery'
const $ = window.$

globalThis.processForm = function () {
  return {
    ...getPurchaseForm(),
    ...getContactForm(),
    ...handleMultiCheckboxForm(),
    ...getAppointmentScheduleRequestForm(),
  }
}

export type FormPurchaseProductType = {
  id: string
  price_id?: number
  quantity: number
}

export type FormPurchaseType = {
  purchase: {
    product_variants: FormPurchaseProductType[]
    coupon_codes: string[]
    rebilly_token?: string
  }
}

export type FormAppointmentScheduleRequestType = {
  appointments_schedule_request: {
    email: string
    comments?: string
    host_id: string
    event_type_id: string
    start_on: string
    end_on: string
    tzid: string
  }
}

export type cfARInputOptions = {
  param?: string
  prefix?: string
  keep?: boolean
}

export function restoreButtonState(): void {
  $('.elBTN a[href="#submit-form"]').each(function () {
    const $this = $(this)
    const $text = $this.find('.elButtonMainText')
    const $subText = $this.find('.elButtonSub')
    const previousText = $this.attr('data-before-submit-text')
    const previousSub = $this.attr('data-before-submit-sub')
    const loadingSpinner = $text.parent().find('.elButtonSpinner')
    loadingSpinner.css('display', 'none')
    if (previousText) {
      $this.removeClass('cf-submitting-page')
      $text.text(previousText)
      $subText.text(previousSub)
      $this.removeAttr('data-before-submit-text')
      $this.removeAttr('data-before-submit-sub')
    }
  })
}

function setButtonSubmitText(text?: string, subtext?: string): void {
  $('.elBTN a[href="#submit-form"]').each(function () {
    const $this = $(this)
    const $text = $this.find('.elButtonMainText')
    const $subText = $this.find('.elButtonSub')
    const submitText =
      text ??
      ($this.attr('data-param-submittingtext')?.length ? $this.attr('data-param-submittingtext') : 'Submitting...')
    const dataBeforeSubmit = $this.attr('data-before-submit-text')
    if (!dataBeforeSubmit) {
      $this.attr('data-before-submit-text', $text.text())
      $this.attr('data-before-submit-sub', $subText.text())
      $this.addClass('cf-submitting-page')
    }
    const loadingSpinner = $this.find('.elButtonSpinner')
    $text.text(`${submitText}`)
    $subText.text(subtext ?? '')
    loadingSpinner.css('display', 'inline-block')
  })
}

async function sleepMs(timeMs: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, timeMs)
  })
}

function getRenderedHref() {
  const renderedPage = document.querySelector('meta[name="rendered-page-url"]')?.getAttribute('content')
  const renderedPath = renderedPage ?? window.location.pathname
  const url = new URL(window.location.href)
  url.pathname = renderedPath
  return url.toString()
}

async function submitOrderAsync(
  body: string,
  maxRetries = 3,
  onBeforeSubmit: () => void,
  onRetryAfter: (sleepTime: number) => void
): Promise<Response> {
  let response: Response
  for (let i = 0; i < maxRetries; i++) {
    try {
      onBeforeSubmit()
      response = await fetch(getRenderedHref(), {
        credentials: 'same-origin',
        method: 'post',
        body,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CF2-POST-TYPE': 'submit',
        },
      })
      if (response.status === 429) {
        const sleepTime = parseInt(response.headers.get('Retry-After'))
        onRetryAfter(sleepTime)
        console.log(`Waiting on queue, retrying after ${sleepTime}`)
        await sleepMs(sleepTime)
      } else {
        break
      }
    } catch (err) {
      console.log(err)
      await sleepMs(5000)
    }
  }
  return response
}

export function submitPage(): void {
  const data = globalThis.processForm()
  $('#cfAR .purchaseInput').remove()

  // TODO: it would be nice to post this in JSON instead of using #cfAR submit
  // problem here is that on redirect, rails returns the page to redirect to, and
  // not the URL of the page in that case.
  data.purchase?.product_variants?.forEach((pv) => {
    $('#cfAR').append(
      `<input type="text" class="purchaseInput" name="purchase[product_variants][][id]" value="${pv.id}" />`
    )
    $('#cfAR').append(
      `<input type="number" class="purchaseInput" \
name="purchase[product_variants][][quantity]" value="${pv.quantity}"/>`
    )
    $('#cfAR').append(
      `<input type="number" class="purchaseInput" name="purchase[product_variants][][price_id]" value="${pv.price_id}" />`
    )
  })
  data.purchase?.coupon_codes?.forEach((couponCode: string) => {
    $('#cfAR').append(
      `<input type="text" class="purchaseInput" name="purchase[coupon_codes][]" value="${couponCode}" />`
    )
  })

  $('#cfAR').append('<input type="text" class="purchaseInput" name="purchase[process_new_order]" value="true" />')

  clearBlankInputFields()
  const formData = $('#cfAR').serialize()
  let timer: NodeJS.Timeout = null
  globalThis.CFDispatchEvent(CFEvents.FORM_SUBMITTED, data)

  submitOrderAsync(
    formData,
    3,
    () => {
      clearInterval(timer)
      setButtonSubmitText()
    },
    (sleepTime) => {
      let remainingSeconds = sleepTime / 1000
      clearInterval(timer)
      timer = setInterval(() => {
        remainingSeconds -= 1
        setButtonSubmitText('Waiting on queue', `(Retrying in ${remainingSeconds}s)`)
      }, 1000)
    }
  )
    .then((response) => {
      if (response.status == 422) {
        response.json().then((responseJson) => {
          clearInterval(timer)
          window.dispatchEvent(
            new CustomEvent('checkout:order-submit-errors', {
              detail: {
                error: `Failed to submit: ${responseJson.error}`,
              },
            })
          )
          restoreButtonState()
        })
      } else if (response.ok) {
        globalThis.CFDispatchEvent(CFEvents.FORM_SUBMITTED_OK, data)
        restoreButtonState()
        if (response.headers.get('X-CF2-APPROVAL-URL')) {
          const approvalUrl = response.headers.get('X-CF2-APPROVAL-URL')
          const auxWrapper = document.querySelector('.multiple-payment-aux-frame')
          const $auxWrapper = $(auxWrapper)
          const iframe = document.createElement('iframe')
          const orderStautsIframe = '/cf_order_status?disable-dispatch=true'
          iframe.onload = () => {
            if (iframe.src.includes(orderStautsIframe)) {
              $auxWrapper.css('display', 'flex')
              iframe.src = approvalUrl
            }
          }
          auxWrapper.innerHTML = ''
          auxWrapper.appendChild(iframe)
          iframe.src = orderStautsIframe
        } else {
          globalThis.CFDispatchEvent(CFEvents.FORM_SUBMITTED_FINALIZED, data)
          window.location.href = response.headers.get('Location')
        }
      } else if (response.status === 429) {
        clearInterval(timer)
        setButtonSubmitText('Failed to submit', 'Retry again in a few seconds')
        sleepMs(5000).then(() => {
          window.dispatchEvent(new CustomEvent('payments:submit-failed'))
          restoreButtonState()
        })
      } else if (response.status >= 300 && response.status < 400) {
        window.location.href = response.headers.get('Location') ?? window.location.href
      } else {
        window.dispatchEvent(new CustomEvent('checkout:order-submit-errors'))
      }
    })
    .catch((err) => {
      console.log(err)
      clearInterval(timer)
      window.dispatchEvent(new CustomEvent('payments:submit-failed'))
      restoreButtonState()
    })
}
globalThis.submitPage = submitPage

function clearBlankInputFields(): void {
  $('#cfAR')
    .find('input,select,textarea')
    .each((index: number, input: HTMLInputElement) => {
      if (input.value == '' && !input.classList.contains('keep')) {
        input.remove()
      }
    })
}

function getPurchaseForm(): FormPurchaseType | Record<string, never> {
  const orderCart = window['OrderCart/V1']?.default
  if (!orderCart) return {}
  const products = orderCart?.productVariants
  const formPurchaseProductVariants = products?.map((product) => {
    return {
      id: product.id,
      price_id: product.priceId,
      quantity: product.quantity,
    }
  })
  const rebillyToken = $('#cfAR input[data-rebilly="token"]').val()

  return {
    purchase: {
      product_variants: formPurchaseProductVariants,
      rebilly_token: rebillyToken as string,
      coupon_codes: [orderCart?.couponCode].filter(Boolean),
    },
  }
}

function getAppointmentScheduleRequestForm() {
  const request = { appointments_schedule_request: {} }
  document.querySelectorAll('.appointment_schedule_request_field').forEach((field: HTMLInputElement) => {
    const fieldName = field.getAttribute('name')?.replace('appointment_schedule_request_', '')

    cfARAppendInput(`appointments_schedule_request[${fieldName}]`, field.value, {
      param: `appointments_schedule_request[${fieldName}]`,
    })
    request.appointments_schedule_request[fieldName] = field.value
  })

  const emailField: HTMLInputElement = document.querySelector("[name='email']")
  if (emailField) {
    const cfEmailInput: HTMLInputElement = document.querySelector('#cf_contact_email')
    cfEmailInput.value = emailField.value
  }

  const guestEmailInputs = document.querySelectorAll<HTMLInputElement>('input.guest-input')
  const guestEmailStrings = []
  guestEmailInputs.forEach((i) => guestEmailStrings.push(i.value))
  cfARAppendInput('appointments_schedule_request[guest_emails]', guestEmailStrings.join(','))
  return request
}

// NOTE: This method changes #cfAR according to page content input elements,
// and it also returns an object with all contact attributes (based on legacy code)
function getContactForm() {
  const data = { contact: {} }
  $('.elFormItem:not([data-prevent-submit="true"])').each(function () {
    const $this = $(this)
    if ($this.parents('[data-page-element="Checkout/V2"]').length > 0) return
    let name = $this.attr('name')
    if (name == '' || name == 'not-set') return

    // TODO: This ia n FHL workaround for submitting country and state as
    // shipping country and state.
    if (['country', 'state'].includes(name)) {
      name = 'shipping_' + name
    }

    let value = $this.val()

    if (name == 'phone_number' && this.iti) {
      value = this.iti.getNumber()
    }

    if (this.getAttribute('type') == 'checkbox') {
      if (name.endsWith('[]')) {
        const checkboxName = name.slice(0, -2)
        if (!data.contact[checkboxName]) {
          data.contact[checkboxName] = []
        }
        if ($this.is(':checked')) {
          data.contact[checkboxName].push(value)
        } else {
          const index = data.contact[checkboxName].indexOf(value)
          if (index > -1) {
            data.contact[checkboxName].splice(index, 1)
          }
        }
        // Return early as we handle the checkbox[] logic for #cfAR separately
        return
      } else {
        value = $this.is(':checked')
        data.contact[name] = value
      }
    } else if (value) {
      data.contact[name] = value
    }

    const $contactInput = $('#cf_contact_' + name)
    // custom type
    if ($contactInput.length == 0 && name) {
      let customType = name.toLowerCase()

      // If you type 'Make of Vehicle' in custom field name,
      //it was passed as 'make_of vehicle' param and we're failing.
      // Yep, we're explicit that "Custom Type accepts letters and numbers only.",
      // but customers do not care, so it's easier just to fix that.
      customType = customType.replace(/\s+/g, '_')
      $('#cf_contact_' + customType).remove()

      cfARAppendInput(customType, value, { prefix: 'cf_contact_' })
    } else {
      if ($this.attr('data-prevent-submit') == 'true') {
        $contactInput.val('')
      } else {
        $contactInput.val(value) //.attr('name', name);
      }
    }
  })
  return data
}

function handleMultiCheckboxForm() {
  $('.elGroupedCheckbox .elFormItem:not([data-prevent-submit="true"])').each(function () {
    const $this = $(this)
    const name = $this.attr('name')
    const value = $this.val()
    const checked = $this.is(':checked')
    if (checked && value && !document.querySelector(`#cfAR input[name="${name}"][value="${value}"]`)) {
      cfARAppendInput(name, value)
    } else if (!document.querySelector(`#cfAR input[name="${name}"]`)) {
      // if not checked and if not already added to the form, add an empty value to the form to clear the attribute later
      cfARAppendInput(name, '', { keep: true })
    }
  })
  return {}
}

function cfARAppendInput(name: string, value: string, options: cfARInputOptions = {}) {
  const input = <HTMLInputElement>document.createElement('INPUT')
  const prefix = options['prefix'] || 'cf_'
  const param = options['param'] || name
  const keep = options['keep'] || false
  input.id = prefix + name
  input.name = name
  input.setAttribute('value', value as string)
  if (keep) {
    input.classList.add('keep')
  }
  input.setAttribute('data-cf-form-field', name)
  input.setAttribute('data-param', param)
  input.setAttribute('data-storage', 'false')
  $('#cfAR').append(input)
}

function validateEmail(email) {
  email = $.trim(email)
  const re = /^(([^<>()[\]\\.,;:#`%\s@"]+(\.[^<>()[\]\\.,;:#`%\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  return re.test(email)
}

function updateInputStyle(selectedInput: JQuery, type: 'error' | 'valid') {
  if (type === 'error') {
    selectedInput.css('border-color', '#B91517')
    selectedInput.css('border-width', '3px')
    selectedInput.css('border-style', 'solid')
  } else {
    selectedInput.css('border-color', '#4a8920')
    selectedInput.css('border-width', '3px')
    selectedInput.css('border-style', 'solid')
  }
}

export function checkValidInputs(): boolean {
  const popupVisibleCheck = $('.modal-wrapper').is(':visible')
  let fail = false
  let elementPathSelector
  if (popupVisibleCheck == true) {
    // check only in the pop up
    elementPathSelector = '#modalPopup .elFormItem.required1, #modalPopup .elFormItem[name="phone_number"]'
  } else {
    // check all that are visible (on page)
    elementPathSelector = '.pageRoot .elFormItem.required1, .pageRoot .elFormItem[name="phone_number"]'
  }
  $(elementPathSelector).each(function () {
    const $this = $(this)
    const visible = $this.is(':visible')
    const isRequired = $this.hasClass('required1')

    if (visible) {
      let value = $this.val()
      const isSelect = $this.is('select')
      if (isSelect) value = $this.find(':selected').attr('value')
      const parent = $this.parents('.elFormItemWrapper')
      const selector = '.inputHolder, .borderHolder, .elCheckbox'
      const selectedInput = parent.length && parent.find(selector).length ? parent.find(selector) : $this
      if (
        selectedInput.is(':checkbox')
          ? !selectedInput.is(':checked')
          : isRequired && (value === null || typeof value === 'undefined' || value === '')
      ) {
        fail = true
        updateInputStyle(selectedInput, 'error')
      } else {
        if (selectedInput.attr('name') == 'email') {
          if (validateEmail(value)) {
            updateInputStyle(selectedInput, 'valid')
          } else {
            fail = true
            updateInputStyle(selectedInput, 'error')
          }
        } else if (selectedInput.attr('name') == 'phone_number' && (selectedInput.get(0) as any).iti) {
          if ((selectedInput.get(0) as any).iti.isValidNumber() || (!isRequired && !value)) {
            updateInputStyle(selectedInput, 'valid')
          } else {
            fail = true
            updateInputStyle(selectedInput, 'error')
          }
        } else {
          updateInputStyle(selectedInput, 'valid')
        }
      }
    }
  })

  // Check for checkbox groups
  if (popupVisibleCheck == true) {
    elementPathSelector = '#modalPopup .elGroupedCheckboxWrapper.required1'
  } else {
    elementPathSelector = '.pageRoot .elGroupedCheckboxWrapper.required1'
  }

  $(elementPathSelector).each(function () {
    const $this = $(this)
    const $checkboxes = $this.find('.elCheckboxInput')
    const checked = $checkboxes.toArray().some((checkbox) => $(checkbox).is(':checked'))
    fail = !checked
    updateInputStyle($this, fail ? 'error' : 'valid')
  })

  return fail == false
}

function mailCheck() {
  const inputsSelector = Array.from(document.getElementsByName('email'))

  inputsSelector.forEach((input, index) => {
    const mailCheckNode = document.createElement('div')
    mailCheckNode.classList.add('mailcheck')
    mailCheckNode.classList.add(`index${index}`)
    input.parentElement.appendChild(mailCheckNode)
    input.addEventListener('blur', function (this: HTMLInputElement) {
      Mailcheck.run({
        email: this.value,
        domains: defaultDomains,
        secondLevelDomains: defaultSecondLevelDomains, // optional
        topLevelDomains: defaultTopLevelDomains, // optional
        suggested: function (suggestion) {
          mailCheckNode.innerHTML = `<span>Did you mean <b>${suggestion.full}?</b></span>`
        },
        empty: function () {
          mailCheckNode.innerHTML = ''
        },
      })
    })
  })
}

// Prevents the user holding down ENTER or clicking multiple times from submitting the form multiple times causing deadlocks
// Taking a very naive approach to reduce footprint and potential risk and still alleviate the most common occurrences.
let lastSubmitTime = 0
const SUBMIT_COOLDOWN = 1000 // 1 second cooldown

function handleEnterSubmit() {
  const popupVisibleCheck = $('.modal-wrapper').is(':visible')
  let buttonsPathSelector: string

  if (popupVisibleCheck == true) {
    buttonsPathSelector = '#modalPopup .elBTN a[href="#submit-form"]:visible'
  } else {
    buttonsPathSelector = '.pageRoot .elBTN a[href="#submit-form"]:visible'
  }
  const submitButton = $(buttonsPathSelector).first()
  const now = Date.now()
  if (now - lastSubmitTime < SUBMIT_COOLDOWN) {
    return
  }
  lastSubmitTime = now
  handleFormSubmit(submitButton)
}

function setupEnterKeySubmit() {
  const inputsPathSelector = '.elFormItem'

  $(inputsPathSelector).each(function () {
    const thisInput = $(this)
    if (thisInput.closest('[data-page-element="Checkout/V1"]').length > 0) {
      return true
    }
    if (thisInput.closest('[data-page-element="Checkout/V2"]').length > 0) {
      return true
    }
    thisInput.on('keypress', function (evt) {
      if ((evt.originalEvent as KeyboardEvent)?.isComposing || evt.keyCode === 229) return
      if (evt.key === 'Enter') {
        handleEnterSubmit()
      }
    })
  })
}

function setRedirectOverride($button) {
  let redirectOverride
  if ($button.parents('.elBTN').length) {
    redirectOverride = $button.attr('data-on-submit-go-to')
  }

  if (redirectOverride) {
    $('#cfAR').append(`<input type="text" class="redirectParams" name="redirect_to" value="${redirectOverride}" />`)
  } else {
    $('#cfAR .redirectParams').remove()
  }
}

function handleFormSubmit($button) {
  setRedirectOverride($button)
  setButtonSubmitText()

  if ($('.pai-payment-methods-inner:visible').length > 0) {
    const $rebillySubmit = $('.pai-submit')
    const $rebillyForm = $('.elPAI')
    if ($rebillySubmit.length) {
      $rebillySubmit.trigger('click')
      return
    } else if ($rebillyForm.length) {
      rebillyProcessOrder()
      return
    } else if (!checkValidInputs()) {
      restoreButtonState()
      return
    }
  }

  if (checkValidInputs()) {
    submitPage()
  } else {
    restoreButtonState()
  }
  return true
}
globalThis.handleFormSubmit = handleFormSubmit
globalThis.setButtonSubmitText = setButtonSubmitText
globalThis.restoreButtonState = restoreButtonState
globalThis.setRedirectOverride = setRedirectOverride
globalThis.clearBlankInputFields = clearBlankInputFields

window.addEventListener('DOMContentLoaded', function () {
  mailCheck()
  setupEnterKeySubmit()
  $(document).on('click', '[href="#submit-form"],[data-element-link="#submit-form"]', function () {
    const $button = $(this)
    if ($button.closest('[data-page-element="Checkout/V1"]').length == 0) {
      handleFormSubmit($button)
    }
  })
})
